<template>
    <div class="form">
        <h4 class="step-title">
            <label for="VehicleTrim">{{vehicle.make}} {{vehicle.model}} Vehicle Trim</label>
        </h4>
        <ValidationObserver v-slot="{ errors, handleSubmit }" @submit.prevent>
            <div class="step-content d-flex flex-column align-items-center">
                <scrollable-button-list v-bind:items="trims" v-bind:onclick="complete" v-if="trims.length > 0"/>
                <div class="step-item" v-if="trims.length == 0">
                    <ValidationProvider mode="eager" vid="vehicleTrim" name="Vehicle trim" rules="required">
                        <input id="vehicleTrimText" class="form-control" type="text" v-on:keyup.enter="enterKeyup" v-model="vehicle.trim">
                    </ValidationProvider>
                </div>
                <div class="step-item" v-if="errors['vehicleTrim'] && errors['vehicleTrim'].length > 0">
                    <div class="alert alert-danger">{{ errors["vehicleTrim"][0] }}</div>
                </div>
                <div class="step-item" v-if="trims.length == 0">
                    <button class="btn step-btn" ref="complete" v-on:click="handleSubmit(complete)">Continue</button>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import ScrollableButtonList from "./shared/ScrollableButtonList.vue"
    import { extend } from "vee-validate";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { required } from "vee-validate/dist/rules";

    extend("required", {
        ...required,
        message: "{_field_} is required."
    });

    export default {
        name: "VehicleTrim",
        components: {
            ScrollableButtonList,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            lead: Object
        },
        data: function() {
            return {
                selected: false,
                trims: []
            }
        },
        created: function() {
            this.loadTrims();
        },
        computed: {
            vehicle: function() {
                return this.lead.vehicles[this.lead.vehicles.length-1];
            },
            trimEntered: function() {
                if (this.trims.length == 0) {
                    return true;
                }

                return this.selected;
            }
        },
        methods: {
            loadTrims: function() {
                if (typeof window.AvengeDigitalWidgetYearMakeModelTrims !== "undefined") {
                    var trimsToAdd = window.AvengeDigitalWidgetYearMakeModelTrims[this.vehicle.year][this.vehicle.make][this.vehicle.model];

                    trimsToAdd.forEach(trimToAdd => {
                        this.trims.push({ text: trimToAdd, value: trimToAdd });
                    });
                }
            },
            enterKeyup: function() {
                this.$refs.complete.click();
            },
            complete: function(vehicleTrim) {
                if (vehicleTrim) {
                    this.vehicle.trim = vehicleTrim;
                }
                this.$emit("complete", this.$options.name, this.vehicle.trim);
            }
        }
    }
</script>

<style scoped>

#VehicleTrim {
    max-width: 175px;
}

</style>
